import React, { useCallback, useMemo } from "react";
import { Form } from "reactstrap";
import { Formik } from "formik";
import * as yup from "yup";
import useAsync from "react-use-async-hook";
import _ from "lodash";

import * as ProfileAPI from "../../../../api/profile";
import { useSetLoading } from "../../../utils/hooks/loader";
import addNotification from "../../../utils/notification/notification";

const PasswordSetup = ({ setup, refreshUserDetail }) => {
    /**
     * Update Password
     */
    const { loading: updatePasswordLoader, execute: executeUpdatePassword } =
        useAsync({
            autoExecute: false,
            task: useCallback(async (payload, formikBag) => {
                payload = {
                    password: payload.newPassword,
                };
                return {
                    res: await ProfileAPI.setPassword(payload),
                    formikBag,
                };
            }, []),
            dataLoader: useCallback(({ res, formikBag }) => {
                formikBag.setSubmitting(false);
                refreshUserDetail();
                addNotification({
                    type: "success",
                    title: "Success",
                    message: _.get(res, "data.message", "Success"),
                });
            }, []),
            onError: useCallback(error => {
                addNotification({
                    type: "danger",
                    title: "Error",
                    message: _.get(
                        error,
                        "response.data.message",
                        "Oops! something went wrong..."
                    ),
                });
            }, []),
        });

    const showLoader = useMemo(
        () => updatePasswordLoader,
        [updatePasswordLoader]
    );
    useSetLoading(showLoader);

    return (
        <Formik
            initialValues={{
                newPassword: "",
                confirmPassword: "",
            }}
            validationSchema={yup.object().shape({
                newPassword: yup
                    .string()
                    .min(6, "Password has to be longer than 6 characters!")
                    .max(20, "Password has to be shorter than 20 characters!")
                    .required("Password is required!"),
                confirmPassword: yup
                    .string()
                    .required("Password is required!")
                    .test(
                        "passwords-match",
                        "Passwords must match",
                        function (value) {
                            return this.parent.newPassword === value;
                        }
                    ),
            })}
            onSubmit={(values, formikBag) => {
                // this.props.doPasswordSetup(values, formikBag);
                executeUpdatePassword(values, formikBag);
            }}
        >
            {({
                values,
                errors,
                touched,
                handleSubmit,
                handleChange,
                handleBlur,
                isSubmitting,
            }) => {
                return (
                    <Form
                        className='passwordDetailsSetup-form'
                        onSubmit={handleSubmit}
                    >
                        <div className='cardbox-wrapper'>
                            <div className='cardbox-heading'>
                                <h4 className='cardbox-heading-name text-capitalize text-black'>
                                    Password Setup
                                </h4>
                            </div>
                            <div className='inputcard-wrapper cardbox-body'>
                                <div className='inputcard-body custom-inputcard-body'>
                                    <div className='inputcard-group two-cardbox d-flex align-items-center justify-content-start'>
                                        <div className='choose-reason inputfield d-flex align-items-center justify-content-between'>
                                            <div className='inputcard-withlabel d-flex align-items-start justify-content-center flex-column'>
                                                <label className='inputcard-label'>
                                                    New Password
                                                </label>
                                                <input
                                                    className='custominputfield'
                                                    type='password'
                                                    name='newPassword'
                                                    placeholder='**********'
                                                    value={values.newPassword}
                                                    disabled={
                                                        !(
                                                            setup &&
                                                            !setup.password
                                                        )
                                                    }
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.newPassword &&
                                                touched.newPassword ? (
                                                    <span
                                                        className='error-input-msg'
                                                        style={{ top: 120 }}
                                                    >
                                                        {errors.newPassword}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className='choose-reason inputfield d-flex align-items-center justify-content-between'>
                                            <div className='inputcard-withlabel d-flex align-items-start justify-content-center flex-column'>
                                                <label className='inputcard-label'>
                                                    Confirm Password
                                                </label>
                                                <input
                                                    className='custominputfield'
                                                    type='password'
                                                    name='confirmPassword'
                                                    placeholder='**********'
                                                    disabled={
                                                        !(
                                                            setup &&
                                                            !setup.password
                                                        )
                                                    }
                                                    onChange={handleChange}
                                                    value={
                                                        values.confirmPassword
                                                    }
                                                    onBlur={handleBlur}
                                                />
                                                {errors.confirmPassword &&
                                                touched.confirmPassword ? (
                                                    <span
                                                        className='error-input-msg'
                                                        style={{ top: 120 }}
                                                    >
                                                        {errors.confirmPassword}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='inputcard-footer'
                                    style={{ justifyContent: "space-between" }}
                                >
                                    {setup && !setup.password && (
                                        <>
                                            <span>
                                                New password must be between 6
                                                to 20 characters.
                                            </span>

                                            <button
                                                type='submit'
                                                disabled={isSubmitting}
                                                className='btn-theme btn-search-wrapper'
                                            >
                                                Save
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default PasswordSetup;
